import client from '../../base-api';

const serviceURL = '/portal/private-coaching/bbq';

const bbqPortalPrivateCoachingService = {

    // V2
    createMICFirstInterviewV2(data: any) {
        return client.post(`${serviceURL}/mic-first-interview-v2-create`, data);
    },
    updateMICFirstInterviewV2(data: any, firstInterviewId: number) {
        return client.put(`${serviceURL}/mic-first-interview-v2-update/${firstInterviewId}`, data);
    },
    updateAsAdminMICFirstInterviewV2(data: any, firstInterviewId: number) {
        return client.put(`${serviceURL}/mic-first-interview-v2-update-as-admin/${firstInterviewId}`, data);
    },


    // 2. PROTOCOL ---
    // Protocol (MIC) V2
    postMICV2Protocol(protocolData: any) {
        return client.post(`${serviceURL}/mic-v2-protocol-create`, protocolData);
    },
    updateMICV2Protocol(protocolData: any, protocolId: number) {
        return client.put(`${serviceURL}/mic-v2-protocol-update/${protocolId}`, protocolData);
    },
    updateAsAdminMICV2Protocol(protocolData: any, protocolId: number) {
        return client.put(`${serviceURL}/mic-v2-protocol-update-as-admin/${protocolId}`, protocolData);
    },

}

export default bbqPortalPrivateCoachingService;